import useGradeFilters from './use-grade-filters'
import { PROGRAM_FILTERS } from '../constants/home-links.constants'

export default function useIsProgramSelectorVisible() {
  const gradeFilters = useGradeFilters()

  return (
    gradeFilters.length > 2 ||
    (gradeFilters.length === 2 &&
      !gradeFilters.includes(PROGRAM_FILTERS.ALL_APPS))
  )
}
